module.exports = __webpack_public_path__ + "img/camion2.22f33513.jpg";